import { ValidationStatus } from 'src/store/lists/interfaces'

export enum ValidationTag {
  VALID = 'verifiedPart',
  INVALID = 'invalidPart',
  DUPLICATE = 'duplicateFound',
}

export interface Part {
  seqno: number
  imgUrl: string
  lineCode: string
  partNum: string
  qty: number
  description: string
  comments: string
  group: string
  validationStatus: ValidationStatus
  isDuplicate: boolean
  validationTag: ValidationTag
  visible: boolean
  originalSeqNo: number
}

export interface PartsBin {
  listBinId: string
  totalParts: number
  parts: Part[]
}
